import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

// Services
import { GestionErreurService } from '../services/_index';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  excludedRoutes: Array<{ method: string; uri: string }> = [
    {
      method: 'POST',
      uri: '/preautorisation'
    },
    {
      method: 'GET',
      uri: '/localisations/'
    },
    {
      method: 'POST',
      uri: '/octrois'
    },
    {
      method: 'PUT',
      uri: '/calculer'
    },
    {
      method: 'POST',
      uri: '/propriete'
    },
    {
      method: 'PUT',
      uri: '/propriete'
    },
    {
      method: 'POST',
      uri: '/uploadPngData'
    },
    {
      method: 'POST',
      uri: '/images'
    },
    {
      method: 'GET',
      uri: '/images'
    },
    {
      method: 'POST',
      uri: '/tracingSpa'
    },
    {
      method: 'GET',
      uri: '/preautorisationsenligne'
    },
    {
      method: 'DELETE',
      uri: '/preautorisationsenligne'
    },
    {
      method: 'GET',
      uri: '/calculerprime'
    },
    {
      method: 'POST',
      uri: '/validercodeinvitation'
    },
    {
      method: 'POST',
      uri: '/preadmissibilite'
    }
  ];

  constructor(private readonly _gestionErreurService: GestionErreurService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // desactive le cache sur les requetes http api
    req = this.disableCache(req);

    // HTTP request being sent out
    return next.handle(req).pipe(
      tap(
        () => {
          // Do nothing for the succesful returns
        },
        err => {
          if (err instanceof HttpErrorResponse) {
            // cas particulier de accesd
            const payloadRedirect = err.error && err.error['redirectUrl'] ? err.error['redirectUrl'] : null;
            if (err.status === 401 && payloadRedirect) {
              window.location.href = payloadRedirect;
              return;
            }

            if (this.shouldIntercept(req, req.url)) {
              // On peut capturer toutes les erreurs backend ici et on redirige vers une page d'erreur
              this._gestionErreurService.erreurHTTPReturned.next(err);
            }
          }
        }
      )
    );
  }

  // disable le cache pour le cas particulier de IE 10/11
  // voir https://medium.com/@tltjr/disabling-internet-explorer-caching-in-your-angular-5-application-3e148f4437ad
  disableCache(req: HttpRequest<any>): HttpRequest<any> {
    if (req.url.includes('/api/') && req.method === 'GET') {
      const newHeaders = req.headers;
      newHeaders.set('Cache-Control', 'no-cache');
      newHeaders.set('Pragma', 'no-cache');
      newHeaders.set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');

      return req.clone({ headers: newHeaders });
    }

    return req;
  }

  shouldIntercept(req: HttpRequest<any>, requestUrl) {
    for (const route of this.excludedRoutes) {
      if (requestUrl && requestUrl != null && requestUrl.indexOf(route.uri) > -1 && route.method === req.method) {
        return false;
      }
    }

    return true;
  }
}
